<template>
    <span v-if="forbidden == 1" class="title-tag" style="background-color: red;margin-left: 5px">
        <Poptip
            word-wrap
            transfer
            trigger="hover"
            width="400"
        >
            <span class="title-tag-forbidden"><PrettyText :text="$t('Components.ForbiddenSpan.text')" /></span>
            <div class="api" slot="content">
                <p>{{ $t('Components.ForbiddenSpan.title') }}{{ memo == "" ? $t('Message.explainEmpty') : memo }}</p>
                <br>
                <p>{{ $t('Components.ForbiddenSpan.explainHint') }}</p>
            </div>
        </Poptip>
    </span>
</template>

<script>
    import PrettyText from "@/components/PrettyText";
    export default {
        name: "forbidden-span",
        props: ["forbidden", "memo"],
        components: {
            PrettyText
        },
    }
</script>

<style scoped>
    .title-tag {
        border-radius: 5px;
        font-size: 12px;
        background: #e3e3e3;
        padding: 2px;
    }
    .title-tag-forbidden{
        color: #ffffff;
        cursor: pointer;
    }
</style>